import { useToast } from '@jaymathew/ui-shared/contexts/ToastContext'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateUserNotification as UpdateUserNotigicationService } from 'API/NotificationsService'
import { HttpsCallableResult } from 'firebase/functions'
import { queryKey } from 'queryOptions/getCommunities'

interface UpdateCommunityInput {
	notificationID: string,
	dismissed?: boolean,
	read?: boolean,
	deleted?: boolean,
}

interface MutationCallbacks {
	onSuccess?: (data: HttpsCallableResult<unknown>) => void
	onError?: (err: Error) => void
}

export const useEditUserNotitifcationMutation = (callbacks: MutationCallbacks = {}) => {
	const queryClient = useQueryClient()
	const { triggerToast } = useToast()

	return useMutation<
		HttpsCallableResult<unknown>,
		Error,
		UpdateCommunityInput
	>({
		mutationFn: UpdateUserNotigicationService,
		onSuccess: async (data) => {
			await queryClient.invalidateQueries({ queryKey: [queryKey] })
			triggerToast('Notification updated successfully', 'success')
			callbacks.onSuccess?.(data)
		},
		onError: (err) => {
			triggerToast(err.message, 'error')
			callbacks.onError?.(err)
		},
	})
}
